export default __webpack_public_path__ + "static/media/logo-hhs-gray.2ae376a3.svg";